import React, { ChangeEvent, useState } from "react";
import { ButtonNew } from "components/buttonNew";
import Input from "components/form/input/Input";
import { PostPasswordResetCode } from "api/rpc/2022-09/passwordReset";
import { StatusCode } from "api/protocols";
import { useAppDispatch } from "hooks/redux";
import { showError } from "redux/actions/ui";
import Popup from "components/popup/Popup";
import { useParams } from "react-router";
import { useTranslation, Trans } from "react-i18next";

interface IRecoveryState {
  email: string;
  successPopupVisibility: boolean;
}

interface IParams {
  clientShortName: string;
}

export default function ForgotPassword(props: { facilityId?: number }) {
  const dispatch = useAppDispatch();
  const [recoveryState, setRecoveryState] = useState<IRecoveryState>({
    email: "",
    successPopupVisibility: false,
  });
  const { clientShortName } = useParams<IParams>();
  const { t, i18n } = useTranslation();
  async function sendPasswordRecovery() {
    const resetRes = await PostPasswordResetCode(
      { email: recoveryState.email, client_short_name: clientShortName },
      true,
    );

    if (resetRes.status === StatusCode.OK) {
      setRecoveryState(prevState => ({ ...prevState, successPopupVisibility: true }));
    } else if (typeof resetRes?.data === "string") {
      dispatch(showError(resetRes.data));
      return;
    } else {
      dispatch(showError(t("Error sending password reset email")));
    }
  }

  function handleEnterKeydown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.code === "Enter" || e.code === "NumpadEnter") {
      void sendPasswordRecovery();
    }
  }

  return (
    <>
      <div className="reservations-login">
        <div className="reservations-login-header-container">
          <div className="reservations-login-header-container-centered">
            <div className="reservations-login-header-container-inner">
              <img src="../../../public/images/Tee-On.png" alt={t('Tee-On Logo')} />
            </div>
          </div>
        </div>

        <div className="reservations-login-container">
          <div className="reservations-login-container-inner">
            <div className="reservations-login-container-group">
              <div className="reservations-login-text-group">
                <p className="sign-in-text">{t("Account Recovery")}</p>
                <br />
                <p className="sign-in-info">{t("Please enter email address for account recovery")}</p>
              </div>

              <div className="reservations-login-input-group">
                <label className="reservations-login-input-label" htmlFor="email">
                  {t("Email Address")}
                </label>
                <Input
                  value={recoveryState.email}
                  onChange={(event: ChangeEvent<HTMLInputElement>) =>
                    setRecoveryState(prev => ({ ...prev, [event.target.id]: event.target.value }))
                  }
                  type="email"
                  labelHidden
                  onKeyDown={handleEnterKeydown}
                  id="email"
                />
              </div>
            </div>
            <br />
            <br />
            <div>
              <ButtonNew
                type="primary"
                block
                onClick={sendPasswordRecovery}
                className="reservations-register-button"
                disabled={recoveryState.email.length < 4}
              >
                {t("SEND")}
              </ButtonNew>
            </div>
          </div>
        </div>
      </div>

      <Popup
        open={recoveryState.successPopupVisibility}
        type="success"
        title={t("Email Sent Successfully")}
        description={t("Check your inbox or spam folder")}
        onOk={() => window.close()}
        okText={t("Back to login")}
      />
    </>
  );
}
